module.exports = "https://static.zego.com/_next/static/images/NoFees-71d7b0b52289fbf9d554e87138adcde9.svg";